var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.01777 7.63636L9.63388 1.8623C10.122 1.43627 10.122 0.745546 9.63388 0.31952C9.14573 -0.106507 8.35427 -0.106507 7.86612 0.31952L0.366117 6.86497C-0.122039 7.291 -0.122039 7.98173 0.366117 8.40775L7.86612 14.9532C8.35427 15.3792 9.14573 15.3792 9.63388 14.9532C10.122 14.5272 10.122 13.8365 9.63388 13.4104L3.01777 7.63636Z",
    fill: "#3EB0CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBlue);
export default __webpack_public_path__ + "static/media/back_blue.a9b1609388190350cc9067e6ebaa8e20.svg";
export { ForwardRef as ReactComponent };